import React from 'react';
import { Link } from 'react-router-dom';
import { Eye, Users, FileText, TrendingUp } from 'lucide-react';

const Home = () => {
  const features = [
    {
      icon: Eye,
      title: 'Transparência Total',
      description: 'Acompanhe todas as despesas e receitas da associação em tempo real.',
    },
    {
      icon: Users,
      title: 'Gestão de Associados',
      description: 'Sistema completo para gerenciamento de membros e suas informações.',
    },
    {
      icon: FileText,
      title: 'Documentação',
      description: 'Acesso fácil a todos os documentos e comprovantes importantes.',
    },
    {
      icon: TrendingUp,
      title: 'Relatórios',
      description: 'Visualize estatísticas e relatórios detalhados sobre as finanças.',
    },
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-brand-brown to-brand-darkBrown text-brand-cream">
        <div className="container mx-auto px-4 py-24 lg:py-40">
          <div className="max-w-4xl">
            <h1 className="font-display text-5xl lg:text-7xl font-bold mb-8 leading-tight">
              Transparência e Compromisso com Nossa Comunidade
            </h1>
            <p className="text-xl lg:text-2xl mb-10 text-brand-beige leading-relaxed">
              Acompanhe nossas ações, despesas e conquistas em tempo real.
              Juntos construímos uma comunidade mais forte e transparente.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/transparencia"
                className="bg-accent-red text-white px-8 py-4 rounded-xl font-semibold text-lg hover:bg-brand-gold transition-all duration-300 text-center shadow-lg"
              >
                Ver Portal de Transparência
              </Link>
              <Link
                to="/sobre"
                className="bg-transparent text-brand-cream px-8 py-4 rounded-xl font-semibold text-lg hover:bg-brand-gold/20 border-2 border-brand-cream transition-all duration-300 text-center"
              >
                Sobre Nós
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-brand-cream">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="font-display text-4xl lg:text-5xl font-bold text-brand-brown mb-6">
              Nossos Recursos
            </h2>
            <p className="text-xl text-brand-brown/80 max-w-2xl mx-auto">
              Conheça as ferramentas que utilizamos para garantir transparência e eficiência na gestão.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 border border-brand-beige hover:border-brand-gold"
                >
                  <div className="h-14 w-14 bg-brand-gold/10 rounded-xl flex items-center justify-center mb-6">
                    <Icon className="h-7 w-7 text-brand-gold" />
                  </div>
                  <h3 className="text-xl font-bold text-brand-brown mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-brand-brown/70 leading-relaxed">{feature.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div className="text-center">
              <div className="font-display text-5xl lg:text-6xl font-bold text-accent-red mb-3">
                100%
              </div>
              <div className="text-lg font-medium text-brand-brown">Transparência</div>
            </div>
            <div className="text-center">
              <div className="font-display text-5xl lg:text-6xl font-bold text-brand-gold mb-3">
                500+
              </div>
              <div className="text-lg font-medium text-brand-brown">Associados</div>
            </div>
            <div className="text-center">
              <div className="font-display text-5xl lg:text-6xl font-bold text-brand-brown mb-3">
                10+
              </div>
              <div className="text-lg font-medium text-brand-brown">Anos de História</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-r from-accent-red to-brand-gold text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="font-display text-4xl lg:text-5xl font-bold mb-8">
            Faça Parte da Nossa Comunidade
          </h2>
          <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed">
            Junte-se a centenas de associados que confiam em nossa gestão transparente e comprometida.
          </p>
          <Link
            to="/sobre"
            className="inline-block bg-white text-brand-brown px-10 py-4 rounded-xl font-bold text-lg hover:bg-brand-cream transition-all duration-300 shadow-lg"
          >
            Saiba Como Participar
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;

